import {IntermediatePart} from "../../parts/intermediatePart";

export default class WallC extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'wall_c';
    this.activeFeatureBeforeAllWalls = null;
    this.partName = 'Wall C';
    this.translateId = "visualizer.bathroom.walls.wall_c";
    this.allWallsApplied = true;
    this.isStoneFeature = true;
    this.homePageTitle = "Walls"
  }

  load(dbFeature) {
    if (dbFeature.displayName.includes("laceholder")) { // exclude ALL s3binding since WALL C can not be ALL (only LG or SM)
      const layoutAbr = this.getParent().layout.getCurrentLayoutAbbreviation();
      dbFeature.s3Bindings = dbFeature.s3Bindings && dbFeature.s3Bindings.filter(binding => {
        return (binding.layout !== "ALL") && (binding.layout === layoutAbr)
      });
      if (!dbFeature.s3Bindings || !dbFeature.s3Bindings.length) {
        return false
      }
    }
    return super.load_(dbFeature, new WallC());
  }

  setZIndex(zIndexes) {
    if(zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Wall_C;
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndexes.Wall_C;
      }
    }
  }

  // handleClick(clickFrom) {
  //   if (clickFrom === 'simpleWall' || clickFrom === 'showerWall' || clickFrom === 'vanityWall') {
  //     const parent = this.getParent();
  //     if (clickFrom === 'simpleWall') {
  //       parent.allWallsApplied = true;
  //     }
  //     parent.activeFeatureBeforeAllWalls = parent.activeFeature;
  //     if (!parent.placeholderChanged) {
  //       parent.rememberToRecoverPlaceholder = true;
  //     }
  //   }
  //   super.handleClick();
  // }

  // unCheckAllWalls(clickFrom, navPart) {
  //   if (clickFrom === 'simpleWall') {
  //     this.allWallsApplied = false;
  //   }
  //   if (!(navPart instanceof WallC)) {
  //     if (this.activeFeatureBeforeAllWalls) {
  //       this.activeFeatureBeforeAllWalls.handleClick();
  //       this.activeFeatureBeforeAllWalls = null;
  //     }
  //     if (this.rememberToRecoverPlaceholder) {
  //       this.placeholderChanged = false;
  //       this.rememberToRecoverPlaceholder = false;
  //     }
  //   }
  // }

}
